// extracted by mini-css-extract-plugin
export default {"container":"contact-content-module__container__vPWVF","icon":"contact-content-module__icon__VZC+J","storybook":"contact-content-module__storybook__q36+0"};